import React, { useState, useContext } from 'react';
import '../styles/SignIn.scss';
import logo from '../assets/images/logo.png';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import axiosInstance from '../utils/axios';
import { ToastContainer, toast } from 'react-toastify';
import { AuthContext } from '../contexts/AuthContext';


const VerifyOtp = () => {
    const { login } = useContext(AuthContext);

    const { email } = useParams();
    const [otp, setOTP] = useState('');
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const currentLocation = useLocation();

    const handleInputChange = (e) => {
        setOTP(e.target.value);

        if (errors[e.target.name]) {
            setErrors((prev) => ({
                ...prev,
                [e.target.name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!otp.trim()) {
            newErrors.otp = 'OTP is required';
        } else if (otp.length !== 6) {
            newErrors.otp = 'Enter a valid otp';
        }

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validation = validateForm();

        if (Object.keys(validation).length > 0) {
            setErrors(validation);
            return;
        }
        setIsLoading(true);
        try {
            const res = await axiosInstance.post("accounts/verify-otp/", {'email': email, 'otp': otp});
            const {access_token, refresh_token, name} = res.data;
            login(name, access_token, refresh_token);
            axiosInstance.defaults.headers['Authorization'] = `Bearer ${access_token}`;
            console.log("verify =====> ");
            const redirectTo = currentLocation.state?.state?.from || "/";
            navigate(redirectTo, { state: currentLocation.state?.state?.state });
        } catch (err) {
            toast(err?.response?.data?.detail || "invalid otp");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="signin-page">
            <div className="container">
                <div className="row justify-content-center">
                <div className="col-md-6 col-lg-5">

                    {/* Header */}
                    <div className="signin-header">
                        <div className="brand-logo">
                            <img src={logo} alt="Logo" className="logo-icon" />
                        </div>
                        <p className="brand-subtitle">Welcome back to GETAM</p>
                    </div>

                    {/* Signin Card */}
                    <div className="signin-card">
                        <h2 className="signin-title h3">Verify OTP</h2>
                        <div className="form-floating">
                            <input
                                type="text"
                                className={`form-control ${errors.otp ? 'is-invalid' : ''}`}
                                id="otp"
                                name="otp"
                                value={otp}
                                onChange={handleInputChange}
                                placeholder="OTP"
                            />
                            <label htmlFor="otp">OTP</label>
                            {errors.otp && <span className="error-message">{errors.otp}</span>}
                        </div>

                        {/* Sign In Button */}
                        <button
                            type="button"
                            className="btn btn-primary-custom"
                            onClick={handleSubmit}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Verifying...' : 'verify OTP'}
                        </button>
                    </div>

                </div>
                </div>
            </div>
            <ToastContainer/>
        </div>
    )
}

export default VerifyOtp
